import React from 'react';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'components/Modal/ModalHeader';
import { connect } from 'react-redux';
import { reduxForm, Field, initialize } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import SettingInteger from 'components/Fields/ReduxForm/SettingInteger';
import * as actTableManagement from 'actions/tableManagement';
import styles from './EditTableModal.css';

const validate = (values, props) => {
  const errors = {};
  const { tables } = props;

  if (!values.name) {
    errors.name = 'This field is required';
  } else if (values.name.length > 10) {
    errors.name = 'Maximum 10 characters';
  }
  if (!values.maxPax) {
    errors.maxPax = 'This field is required';
  } else if (parseInt(values.maxPax) <= 0) {
    errors.maxPax = 'Pax must be greater than zero';
  } else if (parseInt(values.maxPax) > 999) {
    errors.maxPax = 'Pax must be less than 1000';
  }
  if (
    tables &&
    values.name &&
    tables.findIndex(
      _table =>
        _table.name.toLowerCase() === values.name.toLowerCase() &&
        !(
          _table.rowNum === values.rowNum &&
          _table.columnNum === values.columnNum
        )
    ) !== -1
  ) {
    errors.name = 'Duplicate Name';
  }
  return errors;
};

class EditTableModal extends React.Component {
  componentWillMount() {}

  render() {
    const { showEditTableModal, isSubmittingForm, handleSubmit } = this.props;
    return (
      <Modal
        show={showEditTableModal}
        onHide={this._onHide}
        backdrop="static"
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <ModalHeader title={`Edit Table`} />
        <form onSubmit={handleSubmit}>
          <Field component="input" type="hidden" name="id" />
          <Field component="input" type="hidden" name="rowNum" />
          <Field component="input" type="hidden" name="columnNum" />
          <Modal.Body bsClass={`${styles.body} modal-body`}>
            <div className={`row ${styles['pad-control']}`}>
              <div className="col-xs-12">
                <Field
                  component={SettingField}
                  name="name"
                  className="form-control"
                  placeholder="Table Name"
                  maxLength="10"
                />
              </div>
            </div>
            <div className={`row`}>
              <div className="col-xs-8">
                <p>
                  <label>Pax</label>
                </p>
              </div>
              <div className="col-xs-4">
                <Field
                  component={SettingInteger}
                  name="maxPax"
                  positiveNumberOnly
                  maxFractionDigits={0}
                  className="form-control"
                  formName="editTableModal"
                  fieldName="maxPax"
                  feedbackClassName="max-pax"
                  minVal={1}
                  maxVal={999}
                />
              </div>
            </div>

            <div className={`row ${styles['pad-control']}`}>
              <div className="col-xs-8">
                <label>Table Shape</label>
              </div>
              <div className="col-xs-2">
                <div>
                  <label>
                    <Field
                      name="shape"
                      component="input"
                      type="radio"
                      value="Circle"
                      onChange={this._tableShape}
                    />{' '}
                    Circle
                  </label>
                </div>
              </div>
              <div className="col-xs-2">
                <div>
                  <label>
                    <Field
                      name="shape"
                      component="input"
                      type="radio"
                      value="Square"
                      onChange={this._tableShape}
                    />{' '}
                    Square
                  </label>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left" />
            <span className="pull-right">
              <button className="btn btn-default" onClick={this._onHide}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSubmit(this._onSubmitEdit)}
                disabled={isSubmittingForm}
              >
                Confirm
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _tableShape = () => {};

  _onSubmitEdit = values => {
    const { dispatch, tables, groupDetail, originalTables } = this.props;
    dispatch(
      actTableManagement.submitEditTable(
        values,
        tables,
        groupDetail,
        originalTables
      )
    );
  };

  _onHide = e => {
    e.preventDefault();
    e.stopPropagation();
    const { dispatch } = this.props;
    dispatch(
      initialize('editTableModal', {
        id: null,
        shape: 'Circle',
        maxPax: 1,
        name: '',
        rowNum: 0,
        columnNum: 0,
        oldName: '',
      })
    );
    dispatch(actTableManagement.closeEditTableModal());
  };
}

function mapStateToProps(state) {
  const {
    showEditTableModal,
    tables,
    table,
    originalTables,
  } = state.tableManagement.map;
  const { groupDetail } = state.tableManagement.group;
  return {
    showEditTableModal,
    tables,
    table,
    groupDetail,
    originalTables,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'editTableModal',
  validate,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(EditTableModal));
